<template>
  <div class="menuText">
    <div class="header">
      <div style="display: flex;margin:12px 0px">
        <div class="textStyle" style="color: #81889c">{{$t('fuelEfficientDriving.节油驾驶评分')}}</div>
        <div  class="textStyle" >
          <i class="el-icon-arrow-right icon_right"></i>
        </div>
        <div  class="textStyle" style="color: #0f1a3a">{{$t('fuelEfficientDriving.异常驾驶行为')}}</div>
      </div>
      <div style="display:flex;justify-content: end;">
        <searchCpn @handleQuery="handleQuery" :abnormalShow="true" :cpnName="showText" :cpnShow="true" :initSearchType="initSearchType"/>
        <el-form inline>
          <el-form-item style="margin-left: 10px"
            ><el-button type="primary" @click="onClose" :size="size">{{
              $t("driver.返回")
            }}</el-button></el-form-item
          >
        </el-form>
      </div>
    </div>
    <!-- <el-divider></el-divider> -->
    <div
      v-loading="loading"
      style="height: calc(100vh - 250px); overflow-y: auto; padding-right: 16px"
    >
      <el-row :gutter="20">
        <kl-empty v-if="total == 0" />
        <el-col :span="6" v-for="(item, n) in dataList" :key="n">
          <detail_item
            :carNo="item.CarNo"
            :beginTime="item.BeginTime"
            :endTime="item.EndTime"
            :duration="getDurationText(item.Duration)"
            :position="item.Position"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import searchCpn from "@/views/driver/fuel_efficient_driving/components/searchCpn.vue"
import detail_item from "./components/detail_item.vue";
import { mapState } from 'vuex'
export default {
  props:{
  },
  components: {
    detail_item,searchCpn
  },
  data() {
    return {
      cpnName: "",
      loading: false,
      // options: [],
      // typeValue: "1",
      dataList: [],
      startDate: "",
      endDate: "",
      total: undefined,
      vehicles:"",
      vehicleName:"",
      showText:{
        title:"参评企业:",
        text:"",
      },
      initSearchType:"日"
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  mounted() {
    this.searchType = this.$t('fuelEfficientDriving.day');
    this.showText.title = this.$t('fuelEfficientDriving.参评企业')+':'
    const dateData = JSON.parse(this.$route.query.dateData || "{}");
    this.startDate = dateData.startDate;
    this.endDate = dateData.endDate;
    this.showText = dateData.showText;
    this.cpnName = dateData.cpnName;
    this.vehicles = dateData.vehicles;
    this.initSearchType = dateData.initSearchType;
    // this.options = [
    //   { label: "长时间怠速", value: "1" },
    //   { label: "急加速", value: "2" },
    //   { label: "急减速", value: "3" },
    //   { label: "空挡滑行", value: "4" },
    //   { label: "超速行驶", value: "5" },
    //   { label: "空调温度过低", value: "6" },
    // ];
    this.getData();
  },
  methods: {
    getSelectedVehicles() {
      this.vehicles = "";
      this.vehicleName = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles =
            this.vehicles + this.selectedVehicles[k].nodeValue + ",";
          this.vehicleName =
            this.vehicleName + this.selectedVehicles[k].vehicleName + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    handleQuery(val){
      this.startDate = val.beginDate;
      this.endDate = val.endDate;
      this.typeValue = val.typeValue
      this.vehicles = this.getSelectedVehicles();
      if(this.vehicles == ""){
        this.showText.title = this.$t('fuelEfficientDriving.参评企业')+":";
        this.showText.text = this.cpnName;
      }else{
        this.vehicleName = this.vehicleName.substring(0,this.vehicleName.length-1);
        this.showText.title = this.$t('fuelEfficientDriving.参评车辆')+":";
        this.showText.text = this.vehicleName;
      }
      this.getData();
    },
    getDurationText(seconds) {
      if (seconds <= 0) return "0秒";

      // 计算小时、分钟、剩余秒数
      const hours = Math.floor(seconds / 3600); // 1小时 = 3600秒
      const remainingSecondsAfterHours = seconds % 3600; // 剩余秒数（去除小时部分）
      const minutes = Math.floor(remainingSecondsAfterHours / 60); // 1分钟 = 60秒
      const secs = remainingSecondsAfterHours % 60; // 最终剩余秒数

      // 拼接结果（只保留有值的部分，如无小时则不显示）
      let result = "";
      if (hours > 0) result += `${hours}小时`;
      if (minutes > 0) result += `${minutes}分钟`;
      if (secs > 0) result += `${secs}秒`;

      return result;
    },
    getData() {
      this.loading = true;
      this.$api
        .queryFuelEffiGradeScoreBadDrivingDetails({
          OperatorID: this.$store.getters.operator.OperatorId + "",
          BeginDate: this.startDate,
          EndDate: this.endDate,
          VehicleID: this.vehicles,
          QueryType: this.typeValue,
        })
        .then((res) => {
          this.dataList = res.data;
          this.total = res.recordsTotal;
          this.loading = false;
        })
        .catch(() => {
          this.dataList = [];
          this.total = 0;
          this.loading = false;
        });
    },
    change(val) {
      // console.log(val);
      // this.getData();
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    onClose() {
      this.$emit("onClose");

      let view = this.$route;
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
      // this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  margin-top: 20px;
}
/* 直接作用于子元素的文字 */
.textStyle{
  font-weight: 600; /* 子元素自身的样式 */
  font-size: 14px;
}
.el-form-item {
  margin-bottom: 0%;
}
.menuText {
  overflow: hidden;
  height: 100vh;
  // margin-left: 0px;
  // margin-right: 0px;
  background: #f4f8ff;
  padding: 0px 16px;
}
.icon_right {
  font-size: 16px;
  color: #999999;
  font-weight: 600;
  margin: 0px 4px;
}
.inputCpn{
  ::v-deep .el-input__inner{
    background-color: white !important;
    cursor: default  !important;
  }
  ::v-deep .el-input__inner::placeholder {
    color: #0F1A3A; 
    // opacity: 1;
  }
} 
</style>